import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const CLINIC = {
  name: "Clinica Denti Service Bacău",
  address: "Strada Ștefan cel Mare nr. 34, Bacău",
  phone: "0749 153 874",
  phoneTel: "tel:+40749153874",
  whatsapp: "https://wa.me/40749153874?text=Bun%C4%83%20ziua.%20Doresc%20informa%C8%9Bii%20despre%20o%20consulta%C8%9Bie%20la%20Clinica%20Denti%20Service%20Bac%C4%83u.",
  phoneAlt: "0743 782 755",
  hours: "Luni - Vineri, 08:00 - 20:00",
  website: "www.dentiservice.ro",
  since: 1992,
};

const http = axios.create({ baseURL: API });

http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ds_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const api = {
  services: () => http.get("/services").then((r) => r.data),
  doctors: () => http.get("/doctors").then((r) => r.data),
  adminDoctors: () => http.get("/admin/doctors").then((r) => r.data),
  cases: () => http.get("/cases").then((r) => r.data),
  faq: () => http.get("/faq").then((r) => r.data),
  prices: () => http.get("/prices").then((r) => r.data),
  articles: () => http.get("/admin/articles").then((r) => r.data),
  createAppointment: (data) => http.post("/appointments", data).then((r) => r.data),
  login: (email, password) => http.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => http.get("/auth/me").then((r) => r.data),
  listAppointments: () => http.get("/appointments").then((r) => r.data),
  updateAppointment: (id, patch) => http.patch(`/appointments/${id}`, typeof patch === "string" ? { status: patch } : patch).then((r) => r.data),
  deleteAppointment: (id) => http.delete(`/appointments/${id}?confirm=DELETE`).then((r) => r.data),
  adminCreate: (col, payload) => http.post(`/admin/${col}`, payload).then((r) => r.data),
  adminUpdate: (col, id, payload) => http.put(`/admin/${col}/${id}`, payload).then((r) => r.data),
  adminDelete: (col, id) => http.delete(`/admin/${col}/${id}`).then((r) => r.data),
  changePassword: (current_password, new_password) => http.post("/auth/change-password", { current_password, new_password }).then((r) => r.data),
  getSettings: () => http.get("/settings").then((r) => r.data),
  updateSettings: (payload) => http.put("/settings", payload).then((r) => r.data),
  listRedirects: () => http.get("/redirects").then((r) => r.data),
  createRedirect: (payload) => http.post("/redirects", payload).then((r) => r.data),
  updateRedirect: (id, payload) => http.put(`/redirects/${id}`, payload).then((r) => r.data),
  deleteRedirect: (id) => http.delete(`/redirects/${id}`).then((r) => r.data),
  listImages: () => http.get("/images").then((r) => r.data),
  uploadImage: (file, section, alt) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("section", section || "");
    fd.append("alt", alt || "");
    return http.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
};

export const MEDIA_BASE = BASE;
